import { useFormContext } from 'react-hook-form';

import type { SupportTicketDetailSchema } from '@/_containers/support/shared/schemas/support-query-schema';

import type { SupportFilterSchema } from '../filters';

export const useTicketDetailsFormContext = () => {
  const context = useFormContext<SupportTicketDetailSchema>();
  return context;
};

export const useSupportFormContext = () => {
  const context = useFormContext<SupportFilterSchema>();
  return context;
};
